import React from "react"
import { Box } from "@mui/system"
import { Grid, Typography } from "@mui/material"
import PropTypes from "prop-types"
import theme from "../../../../theme/theme"

const InfoItem = ({ label, value }) => {
    return (
        <Box sx={{ display: "flex", flexDirection: "column", gap: "5px" }}>
            <Typography
                variant="contraHeading"
                sx={{ color: theme.palette.primary.white70 }}
            >
                {label}
            </Typography>
            <Typography variant="textBody" color="common.white">
                {value}
            </Typography>
        </Box>
    )
}

InfoItem.propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
}

export const BoxDataCompany = ({ companyData }) => {
    return (
        <Box display="flex" gap={3} flexDirection="column">
            <Box
                sx={{
                    display: "flex",
                    flexDirection: { xxxs: "column" },
                    gap: 0.125,
                    alignItems: "stretch",
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: { xxxs: "column" },
                        gap: 0.125,
                    }}
                >
                    <Grid
                        container
                        direction={{ xxxs: "column", sm: "row" }}
                        pt={3}
                        pb={3}
                        pl={3}
                        sx={{
                            width: { xxxs: "100%" },
                            background:
                                "linear-gradient(90.8deg, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0) 100%)",
                        }}
                    >
                        <Grid
                            item
                            xxxs={2}
                            sm={2}
                            md={3}
                            lg={2}
                            sx={{
                                pb: {
                                    xxxs: 3,
                                },
                            }}
                        >
                            <InfoItem
                                label="Razão social"
                                value={companyData?.RazaoSocial ?? "-"}
                            />
                        </Grid>
                        <Grid
                            item
                            xxxs={2}
                            sm={2}
                            md={3}
                            lg={2}
                            sx={{
                                pb: {
                                    xxxs: 3,
                                },
                            }}
                        >
                            <InfoItem
                                label="Nome Fantasia"
                                value={companyData?.NomeFantasia ?? "-"}
                            />
                        </Grid>

                        <Grid
                            item
                            xxxs={2}
                            sm={2}
                            md={3}
                            lg={2}
                            sx={{
                                pb: {
                                    xxxs: 3,
                                },
                            }}
                        >
                            <InfoItem
                                label="CNPJ"
                                value={companyData?.CPFCNPJ ?? "-"}
                            />
                        </Grid>

                        <Grid
                            item
                            xxxs={2}
                            sm={2}
                            md={3}
                            lg={2}
                            sx={{
                                pb: {
                                    xxxs: 3,
                                },
                            }}
                        >
                            <InfoItem
                                label="Raiz CNPJ"
                                value={companyData?.RaizCNPJ ?? "-"}
                            />
                        </Grid>
                        <Grid
                            item
                            xxxs={2}
                            sm={2}
                            md={3}
                            lg={2}
                            sx={{
                                pb: {
                                    xxxs: 3,
                                },
                            }}
                        >
                            <InfoItem
                                label="Grupo econômico"
                                value={companyData?.GrupoEconomico_Nome ?? "-"}
                            />
                        </Grid>
                        <Grid
                            item
                            xxxs={2}
                            sm={2}
                            md={3}
                            lg={2}
                            sx={{
                                pb: {
                                    xxxs: 3,
                                },
                            }}
                        >
                            <InfoItem
                                label="País"
                                value={companyData?.Pais ?? "-"}
                            />
                        </Grid>
                        <Grid
                            item
                            xxxs={2}
                            sm={2}
                            md={3}
                            lg={2}
                            sx={{
                                pb: {
                                    xxxs: 3,
                                },
                            }}
                        >
                            <InfoItem
                                label="Tipo Cadastro"
                                value={companyData?.TipoCadastro ?? "-"}
                            />
                        </Grid>
                        <Grid
                            item
                            xxxs={2}
                            sm={2}
                            md={3}
                            lg={2}
                            sx={{
                                pb: {
                                    xxxs: 3,
                                },
                            }}
                        >
                            <InfoItem
                                label="Situação Cadastral"
                                value={companyData?.SituacaoCadastral ?? "-"}
                            />
                        </Grid>
                        <Grid
                            item
                            xxxs={2}
                            sm={2}
                            md={3}
                            lg={2}
                            sx={{
                                pb: {
                                    xxxs: 3,
                                },
                            }}
                        >
                            <InfoItem
                                label="Setor"
                                value={companyData?.Setor ?? "-"}
                            />
                        </Grid>
                        <Grid
                            item
                            xxxs={2}
                            sm={2}
                            md={3}
                            lg={2}
                            sx={{
                                pb: {
                                    xxxs: 3,
                                },
                            }}
                        >
                            <InfoItem
                                label="Subsetor"
                                value={companyData?.SubSetor ?? "-"}
                            />
                        </Grid>
                        <Grid
                            item
                            xxxs={2}
                            xs={4}
                            sm={4}
                            md={3}
                            lg={4}
                            sx={{
                                pb: {
                                    xxxs: 3,
                                    md: 0,
                                },
                            }}
                        >
                            <InfoItem
                                label="Site RI"
                                value={companyData?.Site_RI ?? "-"}
                            />
                        </Grid>
                        <Grid item xxxs={2} xs={4} sm={4} md={12} lg={12}>
                            <InfoItem
                                label="Atividade"
                                value={companyData?.Atividade ?? "-"}
                            />
                        </Grid>
                    </Grid>

                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: { xxxs: "column", lg: "row" },
                            gap: 0.125,
                        }}
                    >
                        <Grid
                            container
                            direction={{ xxxs: "column", sm: "row" }}
                            pt={3}
                            pb={3}
                            pl={3}
                            sx={{
                                width: { xxxs: "100%", lg: "67%" },
                                background:
                                    "linear-gradient(90.8deg, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0) 100%)",
                            }}
                        >
                            <Grid
                                item
                                xxxs={2}
                                sm={2}
                                md={3}
                                lg={3}
                                sx={{
                                    pb: {
                                        xxxs: 3,
                                        md: 0,
                                    },
                                }}
                            >
                                <InfoItem
                                    label="Ticker B3"
                                    value={companyData?.Ticker ?? "-"}
                                />
                            </Grid>
                            <Grid
                                item
                                xxxs={2}
                                sm={2}
                                md={3}
                                lg={3}
                                sx={{
                                    pb: {
                                        xxxs: 3,
                                        md: 0,
                                    },
                                }}
                            >
                                <InfoItem
                                    label="Setor B3"
                                    value={companyData?.Setor_B3 ?? "-"}
                                />
                            </Grid>

                            <Grid
                                item
                                xxxs={2}
                                sm={2}
                                md={3}
                                lg={3}
                                sx={{
                                    pb: {
                                        xxxs: 3,
                                        sm: 0,
                                    },
                                }}
                            >
                                <InfoItem
                                    label="Código CVM"
                                    value={companyData?.CodigoCVM ?? "-"}
                                />
                            </Grid>

                            <Grid item xxxs={2} sm={2} md={3} lg={3}>
                                <InfoItem
                                    label="Setor CVM"
                                    value={companyData?.SetorCVM ?? "-"}
                                />
                            </Grid>
                        </Grid>

                        <Grid
                            container
                            direction={{ xxxs: "column", sm: "row" }}
                            pt={3}
                            pb={3}
                            pl={3}
                            sx={{
                                width: { xxxs: "100%", lg: "33%" },
                                background:
                                    "linear-gradient(90.8deg, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0) 100%)",
                            }}
                        >
                            <Grid
                                item
                                xxxs={2}
                                sm={2}
                                md={3}
                                lg={6}
                                sx={{
                                    pb: {
                                        xxxs: 3,
                                        sm: 0,
                                    },
                                }}
                            >
                                <InfoItem
                                    label="Mês Fechamento"
                                    value={companyData?.MesFechamento ?? "-"}
                                />
                            </Grid>
                            <Grid item xxxs={2} sm={2} md={6} lg={6}>
                                <InfoItem
                                    label="Peridiocidade Balanço"
                                    value={
                                        companyData?.PeriodicidadeBalanco ?? "-"
                                    }
                                />
                            </Grid>
                        </Grid>
                    </Box>

                    <Grid
                        container
                        direction={{ xxxs: "column", sm: "row" }}
                        pt={3}
                        pb={3}
                        pl={3}
                        sx={{
                            width: { xxxs: "100%" },
                            background:
                                "linear-gradient(90.8deg, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0) 100%)",
                        }}
                    >
                        <Grid
                            item
                            xxxs={2}
                            sm={2}
                            md={3}
                            lg={2}
                            sx={{
                                pb: {
                                    xxxs: 3,
                                },
                            }}
                        >
                            <InfoItem
                                label="Grupo auditoria"
                                value={companyData?.GrupoAuditoria ?? "-"}
                            />
                        </Grid>
                        <Grid
                            item
                            xxxs={2}
                            sm={2}
                            md={3}
                            lg={2}
                            sx={{
                                pb: {
                                    xxxs: 3,
                                    md: 0,
                                },
                            }}
                        >
                            <InfoItem
                                label="Grupo custodiante"
                                value={companyData?.GrupoCustodiante ?? "-"}
                            />
                        </Grid>

                        <Grid
                            item
                            xxxs={2}
                            sm={2}
                            md={3}
                            lg={2}
                            sx={{
                                pb: {
                                    xxxs: 3,
                                    md: 0,
                                },
                            }}
                        >
                            <InfoItem
                                label="Grupo coordenador lider"
                                value={
                                    companyData?.GrupoCoordenadorLider ?? "-"
                                }
                            />
                        </Grid>

                        <Grid
                            item
                            xxxs={2}
                            sm={2}
                            md={3}
                            lg={2}
                            sx={{
                                pb: {
                                    xxxs: 3,
                                    md: 0,
                                },
                            }}
                        >
                            <InfoItem
                                label="Grupo fiduciário"
                                value={companyData?.GrupoFiduciario ?? "-"}
                            />
                        </Grid>
                        <Grid
                            item
                            xxxs={2}
                            sm={2}
                            md={3}
                            lg={2}
                            sx={{
                                pb: {
                                    xxxs: 3,
                                    md: 0,
                                },
                            }}
                        >
                            <InfoItem
                                label="Grupo IF Recebedora"
                                value={companyData?.GrupoIFRecebedora ?? "-"}
                            />
                        </Grid>
                        <Grid
                            item
                            xxxs={2}
                            sm={2}
                            md={3}
                            lg={2}
                            sx={{
                                pb: {
                                    xxxs: 3,
                                    md: 0,
                                },
                            }}
                        >
                            <InfoItem
                                label="Grupo Securitizador"
                                value={companyData?.GrupoSecuritizador ?? "-"}
                            />
                        </Grid>
                        <Grid item xxxs={2} sm={2} md={6} lg={12}>
                            <InfoItem
                                label="observação"
                                value={companyData?.Observacao ?? "-"}
                            />
                        </Grid>
                    </Grid>
                </Box>
            </Box>
        </Box>
    )
}
BoxDataCompany.propTypes = {
    companyData: PropTypes.shape({
        RazaoSocial: PropTypes.string,
        NomeFantasia: PropTypes.string,
        CPFCNPJ: PropTypes.string,
        RaizCNPJ: PropTypes.string,
        GrupoEconomico_Nome: PropTypes.string,
        Pais: PropTypes.string,
        TipoCadastro: PropTypes.string,
        SituacaoCadastral: PropTypes.string,
        Setor: PropTypes.string,
        SubSetor: PropTypes.string,
        Site_RI: PropTypes.string,
        Atividade: PropTypes.string,
        Ticker: PropTypes.string,
        Setor_B3: PropTypes.string,
        CodigoCVM: PropTypes.string,
        SetorCVM: PropTypes.string,
        MesFechamento: PropTypes.string,
        PeriodicidadeBalanco: PropTypes.string,
        GrupoAuditoria: PropTypes.string,
        GrupoCustodiante: PropTypes.string,
        GrupoCoordenadorLider: PropTypes.string,
        GrupoFiduciario: PropTypes.string,
        GrupoIFRecebedora: PropTypes.string,
        GrupoSecuritizador: PropTypes.string,
        Observacao: PropTypes.string,
    }),
}
